import * as React from 'react';
import { Keyword } from '../../../../interfaces/models';
import { Entity } from '../EntityResults/Result';
import Table from '../../Table';
import { TrashIcon } from '@heroicons/react/24/outline';

interface RelatedKeywordsProps {
  keywords: Keyword[];
  onRemove: (entity: Entity) => void;
}

const RelatedKeywords: React.FC<RelatedKeywordsProps> = ({
  keywords,
  onRemove,
}) => {
  const onRemoveKeyword = (
    e: React.MouseEvent<HTMLButtonElement>,
    keyword: Keyword
  ): void => {
    e.preventDefault();
    onRemove(keyword);
  };

  if (keywords.length > 0) {
    return (
      <>
        <h3 className="medium-title mb-2 mt-3">Keywords / Tags</h3>
        <Table headings={['ID', 'Name', 'Actions']}>
          {keywords.map((keyword) => (
            <tr
              key={`${keyword.__typename}-${keyword.id}`}
              className="hover:bg-gray-50"
            >
              <td className="w-1 px-6 py-2 whitespace-nowrap">{keyword.id}</td>
              <td className="px-6 py-2 whitespace-nowrap">{keyword.name}</td>
              <td className="w-2 px-6 py-2 whitespace-nowrap">
                <button
                  className="btn py-1"
                  onClick={(e) => onRemoveKeyword(e, keyword)}
                >
                  <TrashIcon className="h-5 w-5" />
                </button>
              </td>
            </tr>
          ))}
        </Table>
      </>
    );
  } else {
    return null;
  }
};

export default RelatedKeywords;
